import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styles from './quantity-for-price.module.scss.js';
import { clsx } from '../../external/clsx/dist/clsx.js';
import { FlexBox, ErrorBoundary, ScreenClassProvider, Typography } from '@vp/swan';
import { PriceInternal } from '../price/price.component.js';
import { VatMessageInternal } from '../vat-message/vat-message.component.js';
import { useLocalization } from '../../hooks/useLocalizations.js';
import { formatQuantity } from '../../utils/formatter.util.js';
import { isVatDisabledForLocale } from '../../utils/price.util.js';

const QuantityForPriceInternal = forwardRef((props, ref) => {
  const { className, quantityForPriceConfig, placeholdertext, ...rest } = props;
  const classNames = clsx(className, styles.quantityForPrice);
  const { quantity, vatInc = false, locale, shippingIncl = false, hideShippingMessageInVatMessage } = quantityForPriceConfig;
  const { t } = useLocalization(locale);
  const renderPrice = () => {
    const formattedQuantity = formatQuantity(locale, quantity);
    return /* @__PURE__ */ jsx(Typography, { as: "span", fontSkin: "body-small", textColor: "standard", children: t("priceFor", {
      quantity: formattedQuantity,
      price: /* @__PURE__ */ jsx(PriceInternal, { priceConfig: quantityForPriceConfig, placeholdertext })
    }) });
  };
  const renderVatMessage = () => {
    return /* @__PURE__ */ jsxs(Typography, { as: "span", fontSkin: "body-small", textColor: "standard", children: [
      "(",
      /* @__PURE__ */ jsx(
        VatMessageInternal,
        {
          locale,
          vatAndShippingConfig: { vatInc, shippingIncl, hideShippingMessageInVatMessage },
          placeholdertext,
          textColor: "standard"
        }
      ),
      ")"
    ] });
  };
  const renderPriceInfoWithVat = () => /* @__PURE__ */ jsxs(FlexBox, { gap: 2, alignItems: "center", children: [
    renderPrice(),
    !isVatDisabledForLocale(locale) && renderVatMessage()
  ] });
  return /* @__PURE__ */ jsx(FlexBox, { flexDirection: "column", gap: 1, className: classNames, ...rest, ref, children: renderPriceInfoWithVat() });
});
const QuantityForPrice = forwardRef((props, ref) => /* @__PURE__ */ jsx(ErrorBoundary, { fallback: /* @__PURE__ */ jsx(FlexBox, { fontSkin: "title-subsection", children: props.placeholdertext }), children: /* @__PURE__ */ jsx(ScreenClassProvider, { children: /* @__PURE__ */ jsx(QuantityForPriceInternal, { ...props, ref }) }) }));

export { QuantityForPrice };
